import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";

import { useCenter, useCenterMembers } from "../../../center";
import { PractitionerReportView } from "../../../reports";
import CenterAdminShell from "../components/CenterAdminShell";

/**
 * One member's report as the centre's administrator sees it: the same view
 * the member has, limited to the patients the centre holds.
 */
export default function CenterPractitionerReportPage() {
    const { t } = useTranslation();
    const { therapistId = "" } = useParams();
    const { center, loading } = useCenter();
    const { members } = useCenterMembers(center?.id);

    if (loading || !center) {
        return <p className="p-6 text-sm text-gray-500">{t("common.loading")}</p>;
    }

    const member = members.find((m) => m.therapist_id === therapistId);
    const name = member ? `${member.first_name} ${member.last_name}` : t("center.reports.formerMember");

    return (
        <CenterAdminShell center={center} title={t("reports.center.reportTitle", { name })}>
            <PractitionerReportView
                scope={{ kind: "member", centerId: center.id, therapistId }}
                title={t("reports.center.reportTitle", { name })}
                subtitle={t("reports.memberSubtitle", { name })}
                headerAction={
                    <Link
                        to="/center/reports?section=therapists"
                        className="mb-2 inline-flex items-center gap-1.5 text-sm text-content-secondary hover:text-content-primary"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />
                        {t("reports.backToCenter")}
                    </Link>
                }
            />
        </CenterAdminShell>
    );
}
